import React from 'react';
import {Box, Typography} from '@mui/material';

type PageHeaderProps = {
    title: string;
    subtitle?: string;
    // Buttons and the like, shown at the right (wrapping under the title on narrow screens).
    actions?: React.ReactNode;
    eyebrow?: string;
};

// The heading block shared by the app's pages: a title, a quiet line beneath it, and actions.
export function PageHeader({title, subtitle, actions, eyebrow}: PageHeaderProps) {
    return (
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 3.5}}>
            <Box sx={{minWidth: 0}}>
                {eyebrow && <Typography variant="overline" sx={{display: 'block', color: 'primary.main', fontSize: 11, fontWeight: 700, letterSpacing: '0.12em', mb: 0.75}}>{eyebrow}</Typography>}
                <Typography variant="h4" component="h1" sx={{fontSize: {xs: 27, sm: 32}}}>{title}</Typography>
                {subtitle && (
                    <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>{subtitle}</Typography>
                )}
            </Box>
            {actions && <Box sx={{display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap'}}>{actions}</Box>}
        </Box>
    );
}
